import React, { Component } from 'react';
import '../css/main.css';
import charging from "../img/charging.gif";
import { connect } from "react-redux";


function mapDispatchToProps(dispatch) {
  	return {
  	};
}



class Connected_loading extends Component {



	constructor(props){
    	super(props);
      this.state={
        isLoaded:false
      }
      
  	}
    

    render() {
        return (
          <div id="loaderWrapper">
              <div class="loader"></div>
          </div>
        );
  }
}

const Loading = connect(
  null,
  mapDispatchToProps
)(Connected_loading);

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading.js